import farmActions from './action';

export default {
    state: {
        farm:{},
        farmUni: {id:0, name:"hectare"},
        periUni: {id:0, name:"meter"},
    },
    mutations: {
        loadfarm(state, payLoad) {
            console.log(payLoad)
            state.farm = payLoad;
            state.farm.totalfarmsize=`${payLoad.farmSize} ${state.farmUni.name}`
            state.farm.totalperiSize=`${payLoad.farmPerimeter} ${state.periUni.name}`
        },
    },
    actions: farmActions,
    getters: {
        getfarm(state) {
            return state.farm;
        },
    },
    modules: {
      
    }
}